import React from 'react';
import style from 'css/admin/component.module.css';

function SearchArea({ title, children }) {
  return (
    <div className={style.searchArea}>
      <div className={`${style.searchArea_title} ${!title ? style.searchArea_title_hidden : ''}`}>
        {title}
      </div>
      {children}
    </div>
  );
}

export default SearchArea;
